import React from 'react';

const SearchableSelect = React.forwardRef(({ options = [], value, onChange, placeholder, isMulti = false, className = '', ...props }, ref) => {
  const baseClassName = "block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#0087D4] focus:border-[#0087D4] sm:text-sm bg-white";
  
  if (isMulti) {
    return (
      <select
        ref={ref}
        multiple
        value={Array.isArray(value) ? value.map(v => v?.value || v) : []}
        onChange={(e) => {
          const selectedValues = Array.from(e.target.selectedOptions, option => ({
            value: option.value,
            label: option.text
          }));
          onChange(selectedValues);
        }}
        className={`${baseClassName} ${className}`}
        {...props}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <select
      ref={ref}
      value={value?.value !== undefined && value?.value !== null ? String(value.value) : (value !== undefined && value !== null ? String(value) : '')}
      onChange={(e) => {
        const targetValue = e.target.value;
        const selectedOption = options.find(option => String(option.value) === targetValue);
        if (selectedOption) {
          onChange(selectedOption);
        } else if (targetValue) {
          const numValue = Number(targetValue);
          onChange({ value: isNaN(numValue) ? targetValue : numValue, label: targetValue });
        } else {
          onChange(null);
        }
      }}
      className={`${baseClassName} ${className}`}
      {...props}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
});

SearchableSelect.displayName = 'SearchableSelect';

export default SearchableSelect;
